export * from './lib/services/smart-badge.service';

export * from './lib/types/badge-position.type';
export * from './lib/types/badge-config.type';

export * from './lib/models/badge.model';

export * from './lib/badge.module';
